import * as React from 'react';
import { Transition } from 'react-spring/renderprops';

import * as styles from './checkbox.module.scss';

import { Checked, CheckedCheckmark, Unchecked } from '../../assets/svg';

interface Props {
    label: string;
    usingMouse: boolean;
    disabled?: boolean;
    onClick: (e: React.SyntheticEvent<HTMLDivElement>) => void;
    isSelected: boolean;
    isInvalid?: boolean;
    invalidMessage?: string;
    id?: string;
    checkmark?: boolean
}

const Checkbox = (props: Props) => {
    const {
        id,
        label,
        usingMouse,
        disabled,
        onClick,
        isSelected,
        invalidMessage,
        isInvalid
    } = props;

    if (!label || label.length < 1) {
        // eslint-disable-next-line no-console
        console.error('Web-Gatsby component library: missing button label');
    }
    if (isInvalid && (!invalidMessage || invalidMessage.length < 1)) {
        // eslint-disable-next-line no-console
        console.error('Web-Gatsby component library: missing validation message');
    }
    return (
        <div className={styles.checkboxContainer}>
            {disabled ? (
                <div className={disabled ? styles.disabled : ''}>
                    <span>
                        <Unchecked />
                    </span>
                    <label className='c2'>{label}</label>
                </div>
            ) : (
                <div
                    onClick={onClick}
                    onKeyPress={(e: React.KeyboardEvent<HTMLDivElement>) => {
                        if (e.key === 'Enter') {
                            onClick(e);
                        }
                    }}
                    aria-selected={isSelected}
                    className={usingMouse ? `using-mouse ${styles.checkbox}` : styles.checkbox}
                    tabIndex={0}
                    id={id}>
                    <Transition
                        items={isSelected}
                        from={{ position: 'absolute', opacity: 0 }}
                        enter={{ opacity: 1 }}
                        leave={{ opacity: 0 }}>
                        {toggle =>
                            toggle
                                ? transitionprops => 
                                    <div
                                        style={transitionprops}
                                        className={isInvalid ? styles.invalidChecked : ''}>
                                        {props.checkmark ? <CheckedCheckmark /> : <Checked />}
                                    </div>
                                  
                                : transitionprops => 
                                    <div
                                        style={transitionprops}
                                        className={isInvalid ? styles.invalidUnchecked : ''}>
                                        <Unchecked />
                                    </div>
                                  
                        }
                    </Transition>
                    <label
                        className='c2'
                        style={{
                            marginLeft: '22px',
                            cursor: 'pointer'
                        }} /* has to stay as inline to override spring props */
                        >
                        {label}
                    </label>
                </div>
            )}
            {isInvalid ? <p className={`c2 ${styles.errorMessage}`}>{invalidMessage}</p> : null}
        </div>
    );
};

export default Checkbox;
